import _get from 'lodash/get';
import gqlQueryGetApps from 'graphql/queries/get-apps';
import gqlQueryGetEnvs from 'graphql/queries/get-app-envs';
import gqlQueryGetAppContext from 'graphql/queries/get-app-context';
import gqlQueryGetEnvContext from 'graphql/queries/get-env-context';

export default {
  Mutation: {
    updateAppContext: (_root, variables, { cache }) => {
      const applicationsList = cache.readQuery({ query: gqlQueryGetApps });
      const applications = _get(applicationsList, 'listApplications.items', []);

      const targetApplication = applications.find(
        (app) => app.appId === variables.appId
      );

      if (!targetApplication) {
        return null;
      }

      cache.writeQuery({
        query: gqlQueryGetAppContext,
        data: {
          appContext: [targetApplication]
        }
      });
      return null;
    },
    updateEnvContext: (_root, variables, { cache }) => {
      const envList = cache.readQuery({
        query: gqlQueryGetEnvs,
        variables: { appId: variables.appId }
      });
      const envs = _get(envList, 'listEnvironments.items', []);

      const targetEnv = envs.find((env) => env.uId === variables.envUid);

      if (!targetEnv) {
        return null;
      }

      cache.writeQuery({
        query: gqlQueryGetEnvContext,
        data: {
          envContext: [targetEnv]
        }
      });
      return null;
    }
  },
  Query: {
    appContext: (_root, variables, { cache }) => {
      const { appContext } = cache.readQuery({
        query: gqlQueryGetAppContext
      });
      return appContext;
    },
    envContext: (_root, variables, { cache }) => {
      const { envContext } = cache.readQuery({
        query: gqlQueryGetEnvContext
      });
      return envContext;
    }
  }
};
